import React from 'react';
import { Box } from '@mui/material';

import { getProviderBadgeColor, getProviderInitials } from '../utils/providerBadge';

interface ProviderBadgeProps {
  name: string | null | undefined;
  ariaLabel?: string;
  selected?: boolean;
  size?: 'compact' | 'regular';
}

export const ProviderBadge: React.FC<ProviderBadgeProps> = ({
  name,
  ariaLabel,
  selected = true,
  size = 'compact',
}) => {
  const color = getProviderBadgeColor(name);
  const label = name ? (ariaLabel ?? `Provider: ${name}`) : (ariaLabel ?? 'Unassigned provider');
  const dims =
    size === 'regular'
      ? { height: 24, minWidth: 30, fontSize: 11, px: 0.75 }
      : { height: 18, minWidth: 24, fontSize: 10, px: 0.5 };

  return (
    <Box
      component="span"
      aria-label={label}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: dims.height,
        minWidth: dims.minWidth,
        px: dims.px,
        borderRadius: '4px',
        bgcolor: name && selected ? color : 'transparent',
        color: name ? (selected ? '#fff' : color) : '#9BA1B7',
        border: name && selected ? 'none' : `1.5px solid ${name ? color : '#C6CAD8'}`,
        fontSize: dims.fontSize,
        fontWeight: 700,
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      {getProviderInitials(name)}
    </Box>
  );
};
